<!-- <app-chatbot
  [welcomeMessage1]="
     'Welcome to StudioIP! I\'m Nur, your AI assistant. 🎨

    I\'ll help you create a detailed project brief by asking you a few questions. Let\'s get started!

    What type of creative project are you looking to hire for today?'
  "
  [completionMessages]="[
    'Thank you for the information.',
    'Hang there a moment as I find partners for your project.'
  ]"
  (concatenatedUserMessagesChange)="concatenatedUserMessages = $event"
>
</app-chatbot> -->
<app-chatbot></app-chatbot>

<!-- <div class="user-messages">
  <p>{{ concatenatedUserMessages }}</p>
</div> -->